export interface IdentityKitCompleteMatchForm {
	typeDocument: TypeDocumentEnum;
	document: string;
	name: string;
	surname1: string;
	surname2: string;
}

export enum TypeDocumentEnum {
	DNI_NIF = 'NIF',
	NIE = 'NIE',
}
